import { Wallet, ShoppingBag, RefreshCw, RotateCcw } from "lucide-react";
import StatCard from "../../../component/StatCard";
import { formatCurrency } from "../../../utils/utils";

const DashboardStats = ({ invoice, purchage, direct, inDirect }) => {
  const totalInvoiceAmount = invoice?.reduce(
    (sum, item) => sum + (parseInt(item.total) || 0),
    0
  );
  const totalPurchaseAmount = purchage?.reduce(
    (sum, item) => sum + (parseInt(item.total) || 0),
    0
  );
  const totalDirectAmount = direct?.reduce(
    (sum, item) => sum + (parseInt(item.total) || 0),
    0
  );
  const totalInDirectAmount = inDirect?.reduce(
    (sum, item) => sum + (parseInt(item.total) || 0),
    0
  );
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <StatCard
        icon={<Wallet size={28} />}
        label="Total Sales"
        value={formatCurrency(totalInvoiceAmount)}
      />
      <StatCard
        icon={<ShoppingBag size={28} />}
        label="Total Purchase Order"
        value={formatCurrency(totalPurchaseAmount)}
      />
      <StatCard
        icon={<RefreshCw size={28} />}
        label="Total Direct Sales"
        value={formatCurrency(totalDirectAmount)}
      />
      <StatCard
        icon={<RotateCcw size={28} />}
        label="Total Indirect Sales"
        value={formatCurrency(totalInDirectAmount)}
      />
    </div>
  );
};

export default DashboardStats;
